<h2 class="first_title">Dettaglio documento</h2>
<div export-help [pageNumber]="'197'"></div>
<div class="content-page-wrapper">

  <div class="standardpanel" *ngIf="elaboration$ | async as elaboration">
    <h3>{{elaboration.titolo}}</h3>
    <div class="row ps-static">
      <div *ngIf="isHandsetSizeScreen" class="col-xs-12 col-sm-12">
        <app-document-filter [elaborationId]="elaboration.idElaborazione">
        </app-document-filter>
      </div>
      <div [ngClass]="!isHandsetSizeScreen ? 'col-lg-9' : 'col-xs-12 col-sm-12 col-lg-12'" class="ps-static">
        <app-document-actions-card [elaboration]="elaboration">
        </app-document-actions-card>
        <app-document-detail-tabs [elaborationId]="elaboration.idElaborazione">
        </app-document-detail-tabs>
      </div>
      <div *ngIf="!isHandsetSizeScreen" class="col-lg-3">
        <app-document-filter [elaborationId]="elaboration.idElaborazione">
        </app-document-filter>
      </div>
    </div>
  </div>
</div>

